import React from 'react';
import { IMatrixMessage } from '../../../client/message/types';

interface RoomGuestAccessMessageProps {
  message: IMatrixMessage;
  className?: string;
}

const guestAccessMap: Record<string, string> = {
  can_join: '允许访客加入',
  forbidden: '禁止访客加入',
};

export const RoomGuestAccessMessage = ({ message, className = '' }: RoomGuestAccessMessageProps) => {
  const sender = message.sender;
  const guestAccess = message.content.guest_access;
  const text = guestAccessMap[guestAccess] || guestAccess;
  return (
    <div className={`room-guest-access-message ${className}`} style={{ color: '#43a047', padding: '8px 0' }}>
      {sender ? `${sender} 修改了访客访问权限为「${text}」` : `访客访问权限被修改为「${text}」`}
    </div>
  );
}; 